import "../../../assets/css/global.css";
import "datatables.net-dt";
import "datatables.net";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTranslation } from "react-i18next";
import TranslatorService from "../../../services/Translator/TranslatorService";
import { MessagesSquare } from 'lucide-react';


const HistoryChats = ({
  searchQuery,
  handleSearch,
  handleFilterByAgent,
  chatNames,
  loading,
  filteredChats,
  editAgentName,
  removeAgentName,
  currentPage,
  totalPages,
  handlePageChange,
}) => {
  const { t } = useTranslation();
  const pagesToShow = 5;

  const getPageNumbers = () => {
    const startPage = Math.floor((currentPage - 1) / pagesToShow) * pagesToShow + 1;
    const endPage = Math.min(startPage + pagesToShow - 1, totalPages);
  
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
  
    return pageNumbers;
  };
  
  const handleNext = () => {
    const nextIntervalStart = Math.floor((currentPage - 1) / pagesToShow) * pagesToShow + pagesToShow + 1;
    if (nextIntervalStart <= totalPages) {
      handlePageChange(nextIntervalStart);
    }
  };
  
  const handlePrev = () => {
    const prevIntervalStart = Math.floor((currentPage - 1) / pagesToShow) * pagesToShow - pagesToShow + 1;
    if (prevIntervalStart >= 1) {
      handlePageChange(prevIntervalStart);
    }
  };
  
  const hasPrev = Math.floor((currentPage - 1) / pagesToShow) > 0;
  const hasNext = Math.floor((currentPage - 1) / pagesToShow + 1) * pagesToShow < totalPages;
  
  return (
    <div className="main overflow-auto">
      <div className="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">
                <MessagesSquare />
                &ensp;
                <TranslatorService path="history.title" />
              </a>
            </li>
          </ol>
        </nav>
      </div>
      <div className="container px-4 pt-4">
        <div className="row">
          <div className="col-12 col-titleSection">
            <h1>
              <TranslatorService path="history.title" />
            </h1>
            <p>
              <TranslatorService path="history.description" />
            </p>
          </div>
          <div className="col-12 d-flex flex-wrap mt-3 mb-3">
            <div className="col-12 col-md-5 me-3 mb-3 mb-md-0 flex-column">
              <label htmlFor="search">
                <TranslatorService path="history.searchForName" />
              </label>
              <input
                id="search"
                type="text"
                placeholder={t("history.searchForNamePlaceholder")}
                value={searchQuery}
                onChange={handleSearch}
                className="form-control input-search"
                style={{ flex: "1" }}
              />
            </div>
            <div className="col-12 col-md-3 col-xl-2 flex-column">
              <label htmlFor="agentFilter">
                <TranslatorService path="history.searchFor" />
              </label>
              <select
                id="agentFilter"
                onChange={(e) => handleFilterByAgent(e.target.value)}
                className="form-control"
              >
                <option value="">{t("history.allAgents")}</option>
                {Object.entries(chatNames).map(([key, name]) => (
                  <option key={key} value={key}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-12 card-table text-center mt-3">
            <table id="chat-table" className="table table-striped text-start">
              <thead>
                <tr>
                  <th className="white-color" scope="col">
                    Agente
                  </th>
                  <th className="white-color" scope="col">
                    Titulo
                  </th>
                  <th className="white-color" scope="col">
                    Data
                  </th>
                  <th className="white-color" scope="col" style={{ textAlign: "center" }}>
                    <TranslatorService path="history.tableAction" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array.from({ length: 5 }).map((_, index) => (
                    <tr key={index}>
                      <td>
                        <Skeleton width={100} />
                      </td>
                      <td>
                        <Skeleton width={150} />
                      </td>
                      <td>
                        <Skeleton width={100} />
                      </td>
                      <td>
                        <Skeleton width={150} />
                      </td>
                    </tr>
                  ))
                ) : filteredChats.length === 0 ? (
                  <tr>
                    <td colSpan="4">
                      <TranslatorService path="history.noDataMessage" />
                    </td>
                  </tr>
                ) : (
                  filteredChats.map((chat) => (
                    <tr key={chat.id}>
                      <th
                        className="white-color"
                        scope="row"
                        style={{
                          minWidth: "200px",
                        }}
                      >
                        {chatNames[chat.contextName]}
                      </th>
                      <th
                        className="white-color"
                        scope="row"
                        style={{
                          minWidth: "220px",
                        }}
                      >
                        {chat.title}
                      </th>
                      <td
                        style={{
                          minWidth: "180px",
                          color:"white"
                        }}
                      >
                        {new Date(chat.updatedAt).toLocaleString()}
                      </td>
                      <td
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          gap: "10px",
                        }}
                      >
                        <Link
                          to={`/chat/${chat.context?.projectId ?? chat.contextName}/${chat.id}`}
                          className="btn btn-secondary"
                          style={{
                            minWidth: "120px",
                          }}
                        >
                          <TranslatorService path="history.reopenChat" />
                        </Link>
                        <a
                          href="#edit"
                          onClick={() => editAgentName(chat.id)}
                          className="btn btn-dark"
                        >
                          <TranslatorService path="history.edit" />
                        </a>
                        <a
                          href="#remove"
                          onClick={() => removeAgentName(chat.id)}
                          className="btn btn-danger"
                        >
                          <TranslatorService path="history.remove" />
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="container d-flex justify-content-end mt-3">
      {totalPages > 1 && (
        <nav aria-label="Page navigation">
          <ul className="pagination">
            {hasPrev && (
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handlePrev}
                  aria-label="Previous"
                >
                  <span aria-hidden="true">&laquo;</span>
                </button>
              </li>
            )}

            {getPageNumbers().map((pageNumber) => (
              <li
                key={pageNumber}
                className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
              >
                <button
                  className="page-link blue-main fw-bold"
                  onClick={() => handlePageChange(pageNumber)}
                  disabled={currentPage === pageNumber}
                >
                  {pageNumber}
                </button>
              </li>
            ))}

            {hasNext && (
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handleNext}
                  aria-label="Next"
                >
                  <span aria-hidden="true">&raquo;</span>
                </button>
              </li>
            )}
          </ul>
        </nav>
      )}
      </div>
    </div>
  );
};

export default HistoryChats;